import {
  AddRMeeting, SendEmailToMentor,
  UpdateMentorAvailability,
} from '../../../services/courses';

import BotMessage from './BotMessage';

class ChatBot {
  constructor(mentors) {
    const infoUser = JSON.parse(sessionStorage.getItem('infoUser'));
    this.user = infoUser;
    this.userMessages = [];
    this.step = 0;
    this.mentorsInfo = mentors;
    this.selectedMentor = '';
    this.indexSelectedAlternative = '';
  }

  reply(userMessage) {
    let mentorsName = this.mentorsInfo.map((mentor) => mentor.fullName);

    const kamiRandomAnswers = ['Disculpa, no entendí', 'Elige una alternativa correcta', '¿Cómo dices?', 'Selecciona una opción correcta'];

    if (this.step === 0) {
      if (userMessage > 0 && userMessage <= this.mentorsInfo.length) {
        const message1 = `Esta semana ${mentorsName[userMessage - 1]} tiene la siguiente disponibilidad horaria, elige una:`;
        this.selectedMentor = this.mentorsInfo[userMessage - 1];
        const alternatives = this.mentorsInfo[userMessage - 1].availability;
        const alternatives1 = alternatives.map((a, index) => `${index + 1}. ${a}`);

        if (alternatives.length === 0) {
          const newMessage1 = `Lo siento, esta semana ${mentorsName[userMessage - 1]} ya no cuenta con disponibilidad horaria. Si deseas puedes elegir a otro mentor:`;
          this.mentorsInfo = this.mentorsInfo
            .filter((m) => m.fullName !== this.selectedMentor.fullName);
          mentorsName = mentorsName.filter((m) => m !== this.selectedMentor.fullName);
          const newAlternativesMentors = mentorsName.map((mentor, index) => `${index + 1}. ${mentor}`);
          newAlternativesMentors.push(`${newAlternativesMentors.length + 1}. Mejor en otro momento`);
          return new BotMessage(this.step, newMessage1, newAlternativesMentors);
        }

        this.step += 1;
        return new BotMessage(this.step, message1, alternatives1);
      }

      if (userMessage > this.mentorsInfo.length && userMessage < this.mentorsInfo.length + 2) {
        const messageEnd = 'Comprendo, estoy para ayudarte';
        this.step += 5;

        return new BotMessage(this.step, messageEnd);
      }

      const message2 = kamiRandomAnswers[Math.floor(Math.random() * kamiRandomAnswers.length)];
      return new BotMessage(this.step, message2);
    }

    if (this.step === 1) {
      const newUserMessage = Number(userMessage);
      if (newUserMessage > 0 && newUserMessage <= this.selectedMentor.availability.length) {
        this.indexSelectedAlternative = userMessage - 1;
        const message3 = `Has seleccionado la opción ${userMessage}, ¿procedo a programar la reunión con el mentor?`;
        const alternatives3 = [
          '1. Sí',
          '2. No',
        ];

        this.step += 1;

        return new BotMessage(this.step, message3, alternatives3);
      }

      const message4 = kamiRandomAnswers[Math.floor(Math.random() * kamiRandomAnswers.length)];
      return new BotMessage(this.step, message4);
    }

    if (this.step === 2) {
      if (userMessage === '1') {
        // Scheduling (send email)
        SendEmailToMentor(
          this.selectedMentor.fullName,
          this.user.fullName,
          this.selectedMentor.email,
          this.user.email,
          this.selectedMentor.availability[this.indexSelectedAlternative],
        );

        // Save the schedule
        AddRMeeting(
          this.user.id,
          this.selectedMentor.id,
          this.user.email,
          this.selectedMentor.email,
          this.selectedMentor.availability[this.indexSelectedAlternative],
        );

        // Update mentor availability
        const newAvilability = this.selectedMentor.availability
          .filter((a) => a !== this.selectedMentor.availability[this.indexSelectedAlternative]);
        UpdateMentorAvailability(this.selectedMentor.id, newAvilability);

        // Kami's answer
        const message5 = `Perfecto!!! he agendado la reunión en tu correo corporativo para el: ${this.selectedMentor.availability[this.indexSelectedAlternative]}`;
        const message6 = 'Te recomiendo tener tus consultas preparadas antes de que te reúnas con el mentor, ya que solo contarán con un tiempo de 15 minutos.';
        this.step += 3;

        return [new BotMessage(this.step, message5), new BotMessage(this.step, message6)];
      }

      if (userMessage === '2') {
        const message7 = 'De acuerdo a lo que me indicas, te informo que no se ha programado la reunión.';
        const message8 = 'Si más adelante deseas programar una nueva reuníon estaré aquí para ayudarte.';
        this.step += 3;

        return [new BotMessage(this.step, message7), new BotMessage(this.step, message8)];
      }

      const message9 = kamiRandomAnswers[Math.floor(Math.random() * kamiRandomAnswers.length)];
      return new BotMessage(this.step, message9);
    }

    return null;
  }

  finally() {
    if (this.step === 5) return undefined;
    return null;
  }
}

export default ChatBot;
